/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import Vue from 'vue'
import Router from 'vue-router'
import DishesDetail from '@/views/AadenPages/dishes/dish/detail/DishesDetailPage.vue'
import AddSubscriptionPage from '@/views/AppIndex/Widget/AddSubscriptionPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      component: () => import('@/views/AppIndex/AppIndex.vue'),
      children: [// Dashboard
        {
          name: 'NewDashBoard',
          path: 'statistic/',
          component: () => import('@/views/AadenPages/dashboard/Dashboard.vue'),
          children:
            [// Dashboard
              {
                name: 'dashboard',
                path: '/statistic/overview',
                component: () => import('@/views/AadenPages/dashboard/fragment/OverviewDisplay.vue')
              }
            ]
        },
        {
          name: 'BillAndReport',
          path: 'billAndReport/',
          component: () => import('@/views/AadenPages/dashboard/Dashboard.vue'),
          children:
            [// Dashboard
              {
                name: 'error_page',
                path: '/error',
                component: () => import('@/views/AadenPages/dashboard/fragment/ErrorPage.vue')
              },
              {
                name: 'marketingStatistics', // 产品统计
                path: '/billAndReport/dish-statistics',
                component: () => import('@/views/AadenPages/billAndReport/analysis/report/DishStatistics.vue')
              },
              {
                name: 'bill', // 全部账单
                path: '/billAndReport/history-bills',
                component: () => import('@/views/AadenPages/billAndReport/bills/historyBills/HistoryBills.vue')
              }, {
                name: 'cashBook', // 我的记账本
                path: '/billAndReport/cashbook',
                component: () => import('@/views/AadenPages/cashBook/CashBookManage.vue')
              },
              {
                name: 'cashAccount',
                path: '/billAndReport/cashAccount',
                component: () => import('@/views/AadenPages/cashBook/CashBookCashAccount.vue')
              },
              {
                name: 'discount-rules', // 折扣规则
                path: '/billAndReport/discount-rules-setting',
                component: () => import('@/views/AadenPages/dishes/DiscountRulesSetting.vue')
              },
              {
                name: 'Datev',
                path: '/billAndReport/datev',
                component: () => import('@/views/AadenPages/extraModules/datev/DatevSettingFragment')
              },
              {
                name: 'voucher', // 会员卡销售记录
                path: '/billAndReport/member-card-sale-record',
                props: true,
                component: () => import('@/views/AadenPages/billAndReport/customer/SaledCouponList.vue')
              },
              {
                name: 'voucherStatistic', // 会员卡销售记录
                path: '/billAndReport/voucherStatistic',
                props: true,
                component: () => import('@/views/AadenPages/voucher/VoucherStatistic')
              },
              {
                name: 'salesStatistics',
                path: '/billAndReport/salesStatistics',
                component: () => import('@/views/AadenPages/billAndReport/bills/DishSales.vue')
              },
              {
                name: 'attributeStatistics',
                path: '/billAndReport/attributeStatistics',
                component: () => import('@/views/AadenPages/billAndReport/AttributeStatistics')
              },
              {
                name: 'OperationLog',
                path: '/billAndReport/OperationLog',
                component: () => import('@/views/AadenPages/settings/OperationLog')
              },
              {
                name: 'RevenueAnalysis',
                path: '/billAndReport/analysis',
                component: () => import('@/views/AadenPages/billAndReport/analysis/AnalysisIndexPage.vue')
              },
              {
                name: 'simpleAnalysis',
                path: '/billAndReport/simpleAnalysis',
                component: () => import('@/views/AadenPages/billAndReport/SalesInsight.vue')
              },
              {
                name: 'staffStatistics',
                path: '/billAndReport/staffStatistics',
                component: () => import('@/views/AadenPages/billAndReport/StaffStatistics')
              },
              {
                name: 'staffRecords',
                path: '/billAndReport/staffRecords',
                component: () => import('@/views/AadenPages/billAndReport/StaffRecords.vue')
              },
              {
                name: 'ShiftTracking',
                path: '/billAndReport/worksRecords',
                component: () => import('@/views/AadenPages/billAndReport/WorksRecords')
              },
              {
                name: 'hourlyStatistics',
                path: '/billAndReport/hourlyStatistics',
                component: () => import('@/views/AadenPages/billAndReport/HourlyReport')
              },
              {
                name: 'dailyStatistics',
                path: '/billAndReport/dailyStatistics',
                component: () => import('@/views/AadenPages/billAndReport/DailyStatistics')
              },
              {
                name: 'categoryStatistics',
                path: '/billAndReport/categoryStatistics',
                component: () => import('@/views/AadenPages/billAndReport/CategoryReport')
              },
              {
                name: 'categoryReport',
                path: '/billAndReport/categoryReport',
                component: () => import('@/views/AadenPages/billAndReport/CategoryStatisticalReport')
              },
              {
                name: 'print_bill_list', // 打印单列表
                path: '/billAndReport/printRecordlist',
                component: () => import('@/views/AadenPages/print/PrintRecordList.vue')
              },
              {
                name: 'ZBonList', // Zbon列表
                path: '/billAndReport/ZBonList',
                component: () => import('@/views/AadenPages/billAndReport/bills/ZbonList.vue')
              },
              {
                name: 'ItalyZBon', // Zbon列表
                path: '/billAndReport/ItalyZBon',
                component: () => import('@/views/AadenPages/Italy/ZBonPage.vue')
              },
              {
                name: 'ItalyXML', // Zbon列表
                path: '/billAndReport/ItalyXML',
                component: () => import('@/views/AadenPages/Italy/ItalyXML.vue')
              },
              {
                name: 'Settlement',
                path: '/billAndReport/Settlement',
                component: () => import('@/views/AadenPages/billAndReport/SettlementList.vue')
              },
              {
                name: 'CashBox',
                path: '/billAndReport/CashBox',
                component: () => import('@/views/AadenPages/billAndReport/CashBoxSetting.vue')
              },
              {
                name: 'MilkTea',
                path: '/billAndReport/MilkTea',
                component: () => import('@/views/AadenPages/billAndReport/MilkTeaPage.vue')
              },
              {
                name: 'InventoryLog',
                path: '/billAndReport/InventoryLog',
                component: () => import('@/views/AadenPages/billAndReport/ChangeLogPage.vue')
              }

            ]
        },
        {
          name: 'admin',
          path: 'admin/',
          component: () => import('@/views/AadenPages/dashboard/Dashboard.vue'),
          children: [
            {
              name: 'BillTotal',
              path: '/admin/BillTotal',
              component: () => import('@/views/AadenPages/billAndReport//bills/BillTotal.vue')
            },
            {
              name: 'operationRecords', // 操作记录
              path: '/admin/operationlist',
              component: () => import('@/views/AadenPages/settings/OperationList.vue')
            }
          ]
        },
        {
          name: 'dishDetail',
          path: 'dish/detail/:id',
          props: true,
          component: DishesDetail
        },
        {
          name: 'newExport',
          path: '/billAndReport/newExport',
          component: () => import('@/views/AadenPages/billAndReport/export/ExportPage.vue')
        },
        {
          name: 'category', // 分类
          path: 'dishes/labels-manage',
          component: () => import('@/views/AadenPages/dishes/dish/category/CategoryPage.vue')
        }, {
          name: 'repertory', // 库存
          path: 'dishes/cache-table',
          component: () => import('@/views/AadenPages/dishes/DCacheTable.vue')
        }, {
          name: 'productInfo', // 产品
          path: 'dishes/dishes-manage',
          component: () => import('@/views/AadenPages/dishes/dish/DishesManagePage.vue')
        },
        {
          path: '/dishes/hotpot',
          name: 'HotPot',
          component: () => import('@/views/AadenPages/dishes/dish-display/HopPot')
        },
        {
          name: 'voucherManage',
          path: '/dishes/voucherManage',
          component: () => import('@/views/AadenPages/voucher/VoucherManage')
        },

        {
          name: 'dish_statistics', // 产品统计
          path: '/statistic/dish-statistics',
          component: () => import('@/views/AadenPages/billAndReport/analysis/report/DishStatistics.vue')
        }, {
          name: 'product_out_statistics', // 产品出库统计
          path: 'Sales/dish-delivery-statistics',
          component: () => import('@/views/AadenPages/dishes/DishDeliveryStatistics.vue')
        }, {
          name: 'attribute', // 属性组
          path: 'dishes/attribute-group',
          component: () => import('@/views/AadenPages/dishes/dish/attribute/AttributeGroupPage.vue')

        }, {
          name: 'attributEdit',
          path: 'dishes/attributeByGroup/:groupId',
          props: true,
          component: () => import('@/views/AadenPages/dishes/dish/attribute/AttributePage.vue')

        },

        {
          name: 'menu',
          path: 'dishes/buffet-child-setting',
          component: () => import('@/views/AadenPages/dishes/dish-display/ConsumeTypePage.vue')

        }, {
          name: 'Pfand',
          path: 'dishes/pfand',
          component: () => import('@/views/AadenPages/dishes/PfandSetting')
        }, {
          name: 'discountRule', // 折扣规则
          path: 'dishes/discount-rules-setting',
          component: () => import('@/views/AadenPages/dishes/DiscountRulesSetting.vue')
        }, {
          name: 'threshold_color', // 阈值颜色
          path: 'dishes/threshold-color-setting',
          component: () => import('@/views/AadenPages/dishes/DThresholdColorSetting.vue')
        }, {
          name: 'tableManage', // 桌子
          path: 'settings/Tables/tables-manage',
          component: () => import('@/views/AadenPages/settings/personAndTable/TablesManage.vue')
        }, {
          name: 'roomManage', // 桌子
          path: 'settings/Tables/room-manage',
          component: () => import('@/views/AadenPages/settings/personAndTable/RoomManage.vue')
        }, {
          name: 'person', // 人员
          path: 'settings/person-manage',
          component: () => import('@/views/AadenPages/settings/personAndTable/PersonManage.vue')
        }, {
          name: 'allBills', // 全部账单
          path: 'statistic/bills/history-bills',
          component: () => import('@/views/AadenPages/billAndReport/bills/historyBills/HistoryBills.vue')
        }, {
          name: 'my_cash_book', // 我的记账本
          path: 'statistic/bills/cashbook',
          component: () => import('@/views/AadenPages/billAndReport/cashbook/CashBook.vue')
        },
        {
          name: 'SystemConfig',
          path: 'settings/configItems',
          component: () => import('@/views/AadenPages/settings/ConfigSettings.vue')
        },
        {
          name: 'orderDishesGroupConfig',
          path: 'settings/orderDishesGroup',
          component: () => import('@/views/AadenPages/settings/OrderDishesGroup.vue')
        },

        {
          name: 'printerInfo', // 打印分区
          path: 'settings/print/section-printer-setting',
          component: () => import('@/views/AadenPages/print/SectionPrinterSetting.vue')
        },
        {
          name: 'distributionDistance', // 配送距离
          path: '/TakeawayWeb/delivery-range-setting',
          component: () => import('@/views/AadenPages/extraModules/takeaway/TakeawaySetting/DeliveryRangeSetting.vue')
        },
        {
          name: 'openTime',
          path: 'settings/openTime',
          props: true,
          component: () => import('@/views/AadenPages/settings/OpenTime.vue')
        }, {
          name: 'freeInfoSheet', // 自由信息单old
          path: 'settings/freeInfoSheet',
          component: () => import('@/views/AadenPages/settings/FreeInfoSheet.vue')
        }, {
          name: 'free_info_bon', // 自由信息单
          path: 'print/freeInfoSheet',
          component: () => import('@/views/AadenPages/settings/FreeInfoSheet.vue')
        }, {
          name: 'pay', // 支付
          path: 'settings/TakeawaySetting/paymentpage',
          component: () => import('@/views/AadenPages/settings/PaymentPage.vue')
        }, {
          name: 'allergName', // 过敏源
          path: 'dishes/allergen-setting',
          component: () => import('@/views/AadenPages/dishes/dish/AllergenSettingPage.vue')
        }, {
          name: 'Q&A',
          path: 'settings/q-and-a',
          component: () => import('@/views/AadenPages/settings/QandA.vue')
        }, {
          name: 'restaurantInfo', // 餐馆信息
          path: 'storeInfo/restaurant-info',
          component: () => import('@/views/AadenPages/settings/RestaurantInfo.vue')
        }, {
          name: 'system', // 系统
          path: 'settings/aaden-system-setting',
          component: () => import('@/views/AadenPages/settings/AadenSystemSetting.vue')
        }, {
          name: 'restaurantImage', // 图片
          path: 'settings/restaurant-image',
          component: () => import('@/views/AadenPages/settings/image/RestaurantImage.vue')
        }, {
          name: 'selfServiceOrderingMachine', // 轮播图
          path: 'settings/banner-image',
          component: () => import('@/views/AadenPages/settings/image/BannerImage.vue')
        }, {
          name: 'TaxSetting',
          path: 'settings/tax-setting',
          component: () => import('@/views/AadenPages/settings/TaxSetting.vue')
        }, {
          name: 'TaxType',
          path: 'settings/tax-type',
          component: () => import('@/views/AadenPages/settings/TaxType')
        },
        {
          name: 'Print',
          path: 'settings/Print',
          component: () => import('@/views/AadenPages/print/PrintIndex')
        },
        {
          name: 'ImgSetting',
          path: 'settings/ImgSetting',
          component: () => import('@/views/AadenPages/settings/image/ImgSetting')
        }, {
          name: 'Seite mit den Rechnungsdetails',
          path: 'Details/BillDetail/:id',
          props: true,
          component: () => import('@/views/AadenPages/billAndReport/bills/historyBills/BillDetailPage.vue')
        }, {
          name: 'user_info', // 用户信息
          path: 'Sales/user-management',
          props: true,
          component: () => import('@/views/AadenPages/billAndReport/customer/UserManagement.vue')
        }, {
          name: 'printTemplate',
          path: 'settings/print/bon-template',
          props: true,
          component: () => import('@/views/AadenPages/print/BonTemplate.vue')
        }, // Pages

        {
          name: 'connection',
          path: 'storage/connection',
          props: true,
          component: () => import('@/views/AadenPages/extraModules/storage/DishRelationPage.vue')
        },
        {
          name: 'changeRecord',
          path: 'storage/changeRecord',
          props: true,
          component: () => import('@/views/AadenPages/extraModules/storage/StorageRecords.vue')
        },
        {
          name: 'inventory',
          path: 'storage/inventory',
          props: true,
          component: () => import('@/views/AadenPages/extraModules/storage/InventoryPage.vue')
        }, {
          name: 'reservationTableManage',
          path: 'reserve/reservationTableManage',
          props: true,
          component: () => import('@/views/AadenPages/settings/reserveSetting/UsefulReserveTable.vue')
        }, {
          name: 'tableRule',
          path: 'reserve/tableRule',
          props: true,
          component: () => import('@/views/AadenPages/settings/reserveSetting/tableRule/TableRules.vue')
        }, {
          name: 'openReserve',
          path: 'reserve/openReserve',
          props: true,
          component: () => import('@/views/AadenPages/settings/reserveSetting/reserveDashboard/OpenReserve.vue')
        }, {
          name: 'ingredientSetting',
          path: 'marketLabel/ingredientSetting',
          props: true,
          component: () => import('@/views/AadenPages/extraModules/marketLabel/IngredientSetting.vue')
        }, {
          name: 'ingredientSelect',
          path: 'marketLabel/ingredientSelect',
          props: true,
          component: () => import('@/views/AadenPages/extraModules/marketLabel/IngredientSelect.vue')
        }, {
          name: 'SettingSKU',
          path: 'marketLabel/SettingSKU',
          props: true,
          component: () => import('@/views/AadenPages/extraModules/marketLabel/SettingSKU.vue')
        }, {
          path: '/addSubscription',
          name: 'AddSubscription',
          component: AddSubscriptionPage
        }, {
          path: '/addFirstDevice',
          name: 'AddFirstDevice',
          component: () => import('@/views/AppIndex/Widget/AddFirstDevice.vue')
        }, {
          path: '/personalInfo',
          name: 'PersonalInfoPage',
          component: () => import('@/views/SaaS/personalInfo/PersonalInfoPage.vue')
        }, {
          name: 'takeawayWeb', // 外卖网站设置
          path: '/TakeawayWeb/takeawayWeb',
          component: () => import('@/views/AadenPages/extraModules/takeaway/TakeawayWeb.vue')
        }, {
          path: '/manual',
          name: 'UserManualPage',
          component: () => import('@/views/AadenPages/extraModules/manual/UserManualPage.vue')
        }, {
          path: 'products/productsInfo',
          name: 'ProductsInfo',
          component: () => import('@/views/SaaS/productsInfo/ProductCenter.vue')
        },
        {
          path: 'promotion/PromotionIndex',
          name: 'PromotionIndex',
          component: () => import('@/views/AadenPages/extraModules/promotion/PromotionIndex.vue')
        },
        {
          name: 'ElectronicBilling',
          path: 'settings/ElectronicBillingSetting',
          component: () => import('@/views/AadenPages/settings/ElectronicBilling')
        },

        {
          name: 'reserve',
          path: 'reserve/reserveSetting',
          component: () => import('@/views/AadenPages/settings/reserveSetting/ReserveIndex')
        },
        {
          name: 'takeaway',
          path: 'takeaway/takeaway',
          component: () => import('@/views/AadenPages/extraModules/takeaway/Takeaway.vue')
        },
        {
          name: 'qrScan',
          path: 'qrScan',
          component: () => import('@/views/AadenPages/extraModules/qrScan/QRIndex.vue')
        },
        {
          name: 'storage',
          path: 'storage/storage',
          component: () => import('@/views/AadenPages/extraModules/storage/Storage')
        },
        {
          name: 'branding',
          path: 'branding',
          component: () => import('@/views/AadenPages/branding/StoreBranding')
        },
        {
          name: 'datevManage',
          path: 'datev/datevManage',
          component: () => import('@/views/AadenPages/extraModules/datev/DatevManage')
        },
        {
          name: 'datevDownload',
          path: 'datev/datevDownload',
          component: () => import('@/views/AadenPages/extraModules/datev/DatevDownload')
        },
        {
          name: 'VipManage',
          path: 'Vip/VipManage',
          component: () => import('@/views/AadenPages/VipPage/VipManage')
        },
        {
          name: 'Discount',
          path: 'Vip/Discount',
          component: () => import('@/views/AadenPages/VipPage/VipDiscountPage')
        },
        {
          name: 'Pay',
          path: 'Vip/Pay',
          component: () => import('@/views/AadenPages/VipPage/VipPay')
        },
        {
          name: 'PointSetting',
          path: 'Vip/PointSetting',
          component: () => import('@/views/AadenPages/VipPage/PointRulesSetting')
        },
        {
          name: 'Level',
          path: 'Vip/Level',
          component: () => import('@/views/AadenPages/VipPage/VipMemberLevel')
        },
        {
          name: 'AwardType',
          path: 'Vip/AwardType',
          component: () => import('@/views/AadenPages/VipPage/AwardType.vue')
        },
        {
          name: 'BusinessLayer',
          path: 'Vip/BusinessLayer',
          component: () => import('@/views/AadenPages/VipPage/BusinessLayer.vue')
        },
        {
          name: 'VoucherTypes',
          path: 'Vip/VoucherTypes',
          component: () => import('@/views/AadenPages/VipPage/VoucherTypes.vue')
        },
        {
          name: 'Voucher',
          path: 'Vip/Voucher',
          component: () => import('@/views/AadenPages/VipPage/VoucherIndex.vue')
        },
        {
          name: 'Award',
          path: 'Vip/Award',
          component: () => import('@/views/AadenPages/VipPage/AwardIndex.vue')
        },
        {
          name: 'BLPost',
          path: 'Vip/BLPost',
          component: () => import('@/views/AadenPages/VipPage/BLPost.vue')
        },
        {
          name: 'AllProgress',
          path: 'Vip/AllProgress',
          component: () => import('@/views/AadenPages/VipPage/UserCenter/AllProgress.vue')
        },
        {
          name: 'AllVoucher',
          path: 'Vip/AllVoucher',
          component: () => import('@/views/AadenPages/VipPage/UserCenter/AllVoucher.vue')
        },
        {
          name: 'VipCenter',
          path: 'Vip/VipCenter',
          component: () => import('@/views/AadenPages/VipPage/UserIndex.vue')
        },
        {
          name: 'newCashBook',
          path: 'cashbook/cashbookIndex',
          component: () => import('@/views/AadenPages/cashBook/CashBookIndex.vue')
        },
        {
          name: 'MemberShipLevel',
          path: 'Vip/MemberShipLevel',
          component: () => import('@/views/AadenPages/memberShipReborn/LevelsAndPoints/MembershipLevel.vue')
        },
        {
          name: 'MemberShipBenefit',
          path: 'Vip/MemberShipBenefit',
          component: () => import('@/views/AadenPages/memberShipReborn/Benefit/MembershipBenefit.vue')
        },
        {
          name: 'AssetPage',
          path: 'Vip/AssetPage',
          component: () => import('@/views/AadenPages/memberShipReborn/Asset/AssetPage.vue')
        },
        {
          name: 'UserMembership',
          path: 'Vip/UserMembership',
          component: () => import('@/views/AadenPages/memberShipReborn/userManagement/UserManagement.vue')
        },
        {
          name: 'AwardManagement',
          path: 'Vip/AwardManagement',
          component: () => import('@/views/AadenPages/memberShipReborn/Award/AwardManagement.vue')
        },
        {
          name: 'AssetRecord',
          path: 'Vip/AssetRecord',
          component: () => import('@/views/AadenPages/memberShipReborn/Asset/AssetRecord.vue')
        },
        {
          name: 'AssetRedemption',
          path: 'Vip/AssetRedemption',
          component: () => import('@/views/AadenPages/memberShipReborn/Asset/AssetRedemption.vue')
        },
        {
          name: 'Progress',
          path: 'Vip/Progress',
          component: () => import('@/views/AadenPages/memberShipReborn/Award/ProgressPage.vue')
        },
        {
          name: 'AssetIndex',
          path: 'Vip/AssetIndex',
          component: () => import('@/views/AadenPages/memberShipReborn/Asset/AssetIndex.vue')
        },
        {
          name: 'MemberShipSystemIndex',
          path: 'Vip/MemberShipSystemIndex',
          component: () => import('@/views/AadenPages/memberShipReborn/Core/SystemIndex.vue')
        },
        {
          name: 'AwardManagementIndex',
          path: 'Vip/AwardManagementIndex',
          component: () => import('@/views/AadenPages/memberShipReborn/Award/AwardIndex.vue')
        },
        {
          name: 'MarketingCampaign',
          path: 'Vip/MarketingCampaign',
          component: () => import('@/views/AadenPages/memberShipReborn/MarketingCampaign/MarketingIndex.vue')
        },
        {
          name: 'PointRuleForm',
          path: 'Vip/PointRuleForm',
          component: () => import('@/views/AadenPages/memberShipReborn/LevelsAndPoints/PointRuleForm.vue')
        },
        {
          name: 'UserManagement',
          path: 'vip/management',
          component: () => import('@/views/AadenPages/memberShipReborn/userManagement/UserManagement.vue')
        },
        {
          name: 'DataAnalysis',
          path: 'vip/data-analysis',
          component: () => import('@/views/AadenPages/memberShipReborn/userManagement/DataAnalysis.vue')
        },
        {
          name: 'MembershipSystemHelp',
          path: 'vip/membership-system-help',
          component: () => import('@/views/AadenPages/memberShipReborn/Help/MembershipSystemHelp.vue')
        },
        {
          name: 'LevelsAndPoints',
          path: 'vip/levels-and-points',
          component: () => import('@/views/AadenPages/memberShipReborn/LevelsAndPoints/LevelsAndPoints.vue')
        },
        {
          name: 'RechargeManagement',
          path: 'vip/recharge-management',
          component: () => import('@/views/AadenPages/memberShipReborn/RechargeManagement/RechargeManagementIndex.vue')
        },
        {
          name: 'RechargePackage',
          path: 'vip/recharge-package',
          component: () => import('@/views/AadenPages/memberShipReborn/RechargeManagement/RechargePackage.vue')
        },
        {
          name: 'ShopManagerPassword',
          path: 'vip/shop-manager-password',
          component: () => import('@/views/AadenPages/memberShipReborn/ShopManagerPassword/ShopManagerPassword.vue')
        }
      ]
    },
    {
      path: '/',
      component: () => import('@/views/pages/Index.vue'),
      children: [

        {
          name: 'LoadingPage',
          path: '',
          component: () => import('@/views/pages/LoginPage.vue')
        }, {
          name: 'LoginPage',
          path: '/login',
          component: () => import('@/views/pages/LoginPage.vue')
        },
        {
          name: 'AcceptPage',
          path: '/accept',
          component: () => import('@/views/pages/AcceptPage.vue')
        },
        {
          name: 'CheckPinCode',
          path: '/pinCode',
          component: () => import('@/views/pages/CheckPinCode.vue')
        }, {
          name: 'FirstSubscription',
          path: '/firstSubscription',
          component: () => import('@/views/pages/FirstSubscription.vue')
        }, {
          name: 'OldMemberPage',
          path: '/oldMember',
          component: () => import('@/views/pages/OldMemberPage.vue')
        }, {
          path: '/activeFirstStore',
          name: 'ActiveStore',
          component: () => import('@/views/pages/FirstOwnStore.vue')
        }, {
          path: '/usePINCode',
          name: 'UsePinCode',
          component: () => import('@/views/pages/UsePinCode.vue')
        },
        {
          path: '/error',
          name: 'ErrorPage',
          component: () => import('@/views/pages/Error.vue')
        },
        {
          path: '/needOpenDevice',
          name: 'NeedOpenDevice',
          component: () => import('@/views/pages/NeedOpenDevicePage.vue')
        }
      ]
    },
    {
      path: '/SaaS',
      component: () => import('@/views/SaaS/SaaSIndex.vue'),
      children: [
        {
          path: '/',
          name: 'SaaS',
          component: () => import('@/views/SaaS/SaaSGuide.vue')
        },
        {
          path: '/storeType',
          name: 'choose-store-type',
          component: () => import('@/views/SaaS/ChildrenPage/SelectType.vue')
        },
        {
          path: '/chain',
          name: 'choose-chain',
          component: () => import('@/views/SaaS/ChildrenPage/SelectChainStores.vue')
        },
        {
          path: '/recommended',
          name: 'recommended',
          component: () => import('@/views/SaaS/ChildrenPage/SelectLicenseType.vue')
        },
        {
          path: '/host',
          name: 'host',
          component: () => import('@/views/SaaS/ChildrenPage/SelectHost.vue')
        },
        {
          path: '/service',
          name: 'service',
          component: () => import('@/views/SaaS/ChildrenPage/SelectService.vue')
        }, {
          path: '/free-mod',
          name: 'free-mod',
          component: () => import('@/views/SaaS/ChildrenPage/ChooseProductFromAllPage.vue')
        },
        {
          path: '/waiting-activate',
          name: 'waiting-activate',
          component: () => import('@/views/SaaS/ChildrenPage/WaitingActivate.vue')
        },
        {
          path: '/download-guide',
          name: 'download-guide',
          component: () =>
            import('@/views/SaaS/ChildrenPage/GuideForDownloadApp.vue')
        },
        {
          path: '/input-restaurant-info',
          name: 'input-restaurant-info',
          component: () =>
            import('@/views/SaaS/ChildrenPage/InputRestaurantInfo.vue')
        },
        {
          path: '/order-confirmation',
          name: 'order-confirmation',
          component: () =>
            import('@/views/SaaS/ChildrenPage/CheckOutOverview.vue')
        }
      ]
    }
  ]
})
